import tw from "twin.macro";

export const Wrapper = tw.div`
	py-40
`;
